'use strict'

const _ = require('lodash')

const TARGET_VARIABLES_QUERY = 'variables-masterPage'

/**
 * Checks if the pageJson represents a master page
 * @param {object} pageJson
 * @returns {boolean}
 */
function isMasterPage(pageJson) {
    return _.get(pageJson, 'structure.type') === 'Document'
}

/**
 * Updates master page variablesQuery and migrates data item if needed
 * @param {object} pageJson
 */
function fixMasterPageVariablesQuery(pageJson) {
    const {structure, data} = pageJson

    if (!structure.variablesQuery) {
        return
    }

    const currentQuery = structure.variablesQuery
    if (currentQuery === TARGET_VARIABLES_QUERY) {
        return
    }

    // Get the current data item
    const currentDataItem = _.get(data, ['variables', currentQuery])
    if (!currentDataItem) {
        return
    }

    // Create copy of the data item with the new id
    const newDataItem = {
        ...currentDataItem,
        id: TARGET_VARIABLES_QUERY
    }

    // Update the variables
    data.variables[TARGET_VARIABLES_QUERY] = newDataItem

    // Remove the old data item
    delete data.variables[currentQuery]

    // Update the structure query
    structure.variablesQuery = TARGET_VARIABLES_QUERY
}

/**
 * @exports utils/dataFixer/plugins/masterPageVariablesQueryFixer
 * @type {{exec: function}}
 */
module.exports = {
    name: 'masterPageVariablesQueryFixer',
    version: 0,
    experimentalVersions: [{experiment: 'dm_masterPageVariablesQueryFixer', version: 1}],
    exec(pageJson, pageIdsArray, magicObject) {
        if (!magicObject.isExperimentOpen('dm_masterPageVariablesQueryFixer')) {
            return pageJson
        }

        if (isMasterPage(pageJson)) {
            fixMasterPageVariablesQuery(pageJson)
        }

        return pageJson
    }
}
